import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAllSideArrowsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9.656 6.305 1.913-1.913 1.913 1.913M11.569 10.135V4.396M13.482 17.79l-1.913 1.912-1.913-1.913M11.569 19.698v-5.74M17.308 13.96l1.913-1.913-1.913-1.913M13.48 12.047h5.74M5.827 10.134l-1.913 1.913 1.913 1.913M3.914 12.047h5.74"
    />
  </svg>
);
export default SvgAllSideArrowsIcon;
